var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-flag",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-flag1",
    serifid: "iconB-flag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,14.988l0,-11.988c0,-0.379 0.214,-0.725 0.553,-0.894c-0,-0 2.177,-1.106 5.447,-1.106c1.637,0 3.007,0.526 4.371,1.072c1.136,0.454 2.266,0.928 3.629,0.928c2.059,0 3.011,-0.773 3.296,-0.981c0.119,-0.087 0.214,-0.137 0.274,-0.163c0.374,-0.163 0.66,-0.079 0.842,0.006c0.282,0.13 0.588,0.373 0.588,0.926l0,12.212c0,0.265 -0.105,0.52 -0.293,0.707c0,0 -1.155,1.293 -4.707,1.293c-1.637,0 -3.007,-0.526 -4.371,-1.072c-1.136,-0.454 -2.266,-0.928 -3.629,-0.928c-1.837,0 -3.264,0.405 -4,0.67l0,6.33c0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1c0,0 -0,-7.003 0,-7.012Zm2,-1.421c0.955,-0.281 2.336,-0.567 4,-0.567c1.637,0 3.007,0.526 4.371,1.072c1.136,0.454 2.266,0.928 3.629,0.928c1.543,0 2.532,-0.345 3,-0.561l0,-9.958c-0.711,0.282 -1.689,0.519 -3,0.519c-1.637,0 -3.007,-0.526 -4.371,-1.072c-1.136,-0.454 -2.266,-0.928 -3.629,-0.928c-1.837,0 -3.263,0.405 -4,0.67l0,9.897Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBFlag);
export default __webpack_public_path__ + "static/media/iconB-flag.cbf7c6dc8b5ba86ec6ee26f1848f3b3b.svg";
export { ForwardRef as ReactComponent };